// @flow
export { default } from './BannerLikeButton';



// WEBPACK FOOTER //
// ./src/components/banner/BannerLikeButton/index.js